import React from "react";
import { Typography } from "@mui/material";

// Universal section title styling used across ALL pages
const sectionTitleSx = {
  fontSize: { xs: "1.8rem", md: "2rem" },
  fontWeight: 700,
  lineHeight: 1.25,
  mb: 2,
};

export default function SectionTitle({ children, sx = {}, ...props }) {
  return (
    <Typography
      variant="h4"
      sx={{ ...sectionTitleSx, ...sx }}
      {...props}
    >
      {children}
    </Typography>
  );
}

export const sectionTitleStyle = sectionTitleSx; // <-- export for reuse
